// extracted by mini-css-extract-plugin
module.exports = {"container":"Home_container__3myiG","introText":"Home_introText__2zQuo"};